import { RECOMMENDATION } from "../actionTypes";

const initialState = {
    recommendations: [],
    ipo: {},
    objTopTenRecommendationsData: {},
    recommendationsFilterOptions: [],
    isAPIFailed: false,
};

const recommendationReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case RECOMMENDATION.GET_RECOMMENDATIONS_SUCCESS: {
            return {
                ...state,
                ipo: {
                    ongoingIpo: [{
                        id: 1,
                        companyName: "Craftsman Automation Limited",
                        price: [498, 678],
                        issueDate: "24 MAR '21- 26 APR '21",
                        minAmount: "11,952",
                        lotSize: 15,
                        issueSize: "2,500",
                        image: "img1"
                    }, {
                        id: 2,
                        companyName: "Zomato Pvt.Ltd",
                        price: [498, 678],
                        issueDate: "27 JAN '21- 26 FEB '21",
                        minAmount: "11,952",
                        lotSize: 15,
                        issueSize: "2,500",
                        image: "img2"
                    }, {
                        id: 3,
                        companyName: "Craftsman Automation Limited",
                        price: [498, 678],
                        issueDate: "24 MAR '21- 26 APR '21",
                        minAmount: "11,952",
                        lotSize: 15,
                        issueSize: "2,500",
                        image: "img3"
                    },
                    {
                        id: 4,
                        companyName: "Zomato Pvt.Ltd",
                        price: [498, 678],
                        issueDate: "24 MAR '21- 26 APR '21",
                        minAmount: "11,952",
                        lotSize: 15,
                        issueSize: "2,500",
                        image: "img3"
                    }],
                    upcomingIpo: [{
                        id: 1,
                        companyName: "Craftsman Automation Limited",
                        price: [498, 678],
                        issueDate: "24 MAR '21- 26 APR '21",
                        minAmount: "11,952",
                        lotSize: 15,
                        issueSize: "2,500",
                        image: "img1"
                    }, {
                        id: 2,
                        companyName: "Zomato Pvt.Ltd",
                        price: [498, 678],
                        issueDate: "27 JAN '21- 26 FEB '21",
                        minAmount: "11,952",
                        lotSize: 15,
                        issueSize: "2,500",
                        image: "img2"
                    }],
                    pastIpo: [{
                        id: 1,
                        companyName: "Craftsman Automation Limited",
                        price: [498, 678],
                        issueDate: "24 MAR '21- 26 APR '21",
                        minAmount: "11,952",
                        lotSize: 15,
                        issueSize: "2,500",
                        image: "img1"
                    }, {
                        id: 2,
                        companyName: "Zomato Pvt.Ltd",
                        price: [498, 678],
                        issueDate: "27 JAN '21- 26 FEB '21",
                        minAmount: "11,952",
                        lotSize: 15,
                        issueSize: "2,500",
                        image: "img2"
                    }]


                },
                recommendations: actions.payload,
                isAPIFailed: false,
            };
        }
        case RECOMMENDATION.GET_RECOMMENDATIONS_TAGS: {

            return {
                ...state,
                recommendationsFilterOptions: [
                    // Prachi T :BT-107377 - 23-11-2023 ScripInnfo recommendations - Start 
                    { key: "Status", optionType: 'status', options: [...actions?.payload?.statusTypes] },// options: ['Active', 'Expired', 'Withdrawn']
                    { key: 'Order Types', optionType: 'nBuySell', options: [...actions?.payload?.orderTypes] }, // options: ['Buy', 'Sell']
                    // { key: 'Product Type',optionType:'', options: ['Intraday', 'Delivary', 'Long Term', 'Short Term'] },
                    { key: 'Broker Tags', optionType: 'sRecoTag', options: [...actions?.payload?.tags] }]
                // Prachi T: BT - 107377 - 23 - 11 - 2023 ScripInnfo recommendations - Start
            };
        }
        case RECOMMENDATION.GET_RECOMMENDATIONS_BROKER_TAGS: {
            return {
                ...state,
                recommendationsFilterOptions: state?.recommendationsFilterOptions?.map((filter) =>
                    filter?.optionType === "sRecoTag" ? { ...filter, options: [...actions?.payload] } : filter
                )
            };
        }
        case RECOMMENDATION.GET_RECOMMENDATIONS_FAILURE: {
            return {
                ...state,
                isAPIFailed: true,
                recommendations: actions.payload
            };
        }
        case RECOMMENDATION.TOP_TEN_RECOMMENDATIONS: {
            return {
                ...state,
                objTopTenRecommendationsData: actions.payload
            };
        }
        default:
            return state;
    }

};

export default recommendationReducer;